var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup21449(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 23.109,
    height: 22.544,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21449",
    "data-name": "Group 21449",
    transform: "translate(-16 -164)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 45,
    height: 45,
    rx: 5,
    transform: "translate(16 164)",
    fill: "#0890f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(28.043 176.326)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M0,10.009Q0,7.133,0,4.258A4.13,4.13,0,0,1,4.265,0H15.8a4.125,4.125,0,0,1,4.26,4.255q0,2.947,0,5.894c0,.571-.269.736-.8.543a3.983,3.983,0,0,0-.909-.2c-.417-.046-.569-.183-.569-.613q0-2.79,0-5.581a1.868,1.868,0,0,0-2.027-2.016H4.3A1.868,1.868,0,0,0,2.282,4.3q0,5.723,0,11.446A1.869,1.869,0,0,0,4.307,17.77c2.088,0,4.177.006,6.265-.005a.719.719,0,0,1,.716.435,6.59,6.59,0,0,0,.718.982.529.529,0,0,1,.159.564.5.5,0,0,1-.526.306c-2.535,0-5.069.013-7.6-.008A4.111,4.111,0,0,1,.008,15.988C-.007,14,0,12,0,10.009",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M49.071,51.845a2.472,2.472,0,0,1-.254-.37c-.249-.6-.493-1.21-.727-1.82a2.918,2.918,0,0,0-1.722-1.746c-.617-.243-1.235-.482-1.846-.738-.107-.045-.182-.164-.272-.248.091-.093.166-.224.277-.272q.85-.361,1.715-.683a3.046,3.046,0,0,0,1.886-1.883c.217-.586.451-1.166.694-1.741.044-.105.169-.177.256-.264.086.089.207.163.252.27q.369.877.706,1.767a3,3,0,0,0,1.853,1.838c.595.22,1.184.457,1.768.7.105.044.176.169.263.257-.089.087-.162.21-.269.254q-.878.366-1.77.7a2.986,2.986,0,0,0-1.836,1.818c-.227.6-.47,1.2-.716,1.794a2.335,2.335,0,0,1-.259.364",
    transform: "translate(-30.811 -29.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M18.794,24.633H15.075c-.12.382-.256.772-.363,1.17a.472.472,0,0,1-.568.417,4.077,4.077,0,0,0-.427,0c-.4,0-.515-.162-.4-.539.272-.858.549-1.714.824-2.571.6-1.884,1.215-3.767,1.807-5.656a.491.491,0,0,1,.573-.41,7.366,7.366,0,0,0,.882,0,.45.45,0,0,1,.513.373c.654,2.067,1.32,4.131,1.983,6.2.22.685.443,1.37.661,2.055.125.393.008.552-.408.55-.963,0-.8.11-1.107-.8-.087-.259-.169-.518-.256-.783m-.433-1.384-1.387-4.281-.064,0-1.375,4.283Z",
    transform: "translate(-9.245 -11.864)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M44.27,21.645q0-2.05,0-4.1c0-.4.083-.482.482-.486.913-.009.889-.047.887.881-.005,2.591,0,5.182,0,7.773,0,.437-.077.51-.511.515-.881.011-.863.027-.858-.853.007-1.243,0-2.486,0-3.73",
    transform: "translate(-30.824 -11.877)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup21449);
export default __webpack_public_path__ + "static/media/Group 21449.cbcaf1eebfecab1cb0cebf9d476813a0.svg";
export { ForwardRef as ReactComponent };